module.exports = require('./_shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/~/core-js/modules/_function-to-string.js
// module id = 607
// module chunks = 0